<template>
  <div v-if="isDispatchAddress || isDestinationAddress" class="vz-personal-order-blocks pdf-order-section">
    <div>
      <vz-special-requirement
        v-if="isDispatchAddress"
        :order-lock="orderLockDispatch && !isCloned"
        :simple="simple"
        title-card="Забор груза"
      />
    </div>
    <div>
      <vz-special-requirement
        v-if="isDestinationAddress"
        :order-lock="orderLockDestination && !isCloned"
        :simple="simple"
        title-card="Отвоз груза"
        direction-to
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {storeToRefs} from 'pinia';
import {useOrderStore} from '~/stores/order';
import VzSpecialRequirement from '~/components/personal/order/special-requirements/vz-special-requirement.vue';

const props = defineProps({
  simple: {
    type: Boolean,
    default: false,
  }
})

const {orderForm} = storeToRefs(useOrderStore())

const isCloned = computed(() => {
  return !!useRoute().query.clone
})

const isDispatchAddress = computed(() => {
  return orderForm.value.directions.dispatch.direction === 'address'
})

const isDestinationAddress = computed(() => {
  return orderForm.value.directions.destination.direction === 'address'
})

const orderLockDispatch = computed(() => {
  return !!orderForm.value?.meta?.lockState?.dispatch
})

const orderLockDestination = computed(() => {
  return !!orderForm.value?.meta?.lockState?.destination
})
</script>
